import { PageHeader, Panel, Tag } from "@/components/common";
import { TrendUp, Sparkle, ArrowRight } from "@phosphor-icons/react";
import { toast } from "sonner";

const INSIGHTS = [];

export default function Growth() {
  return (
    <div>
      <PageHeader icon={TrendUp} title="Growth AI"
        subtitle="Studio AI analyses your real performance data to surface patterns — and turns them into new ideas. Correlation is never presented as guaranteed success." />
      <div className="space-y-4">
        {INSIGHTS.length === 0 && <Panel><p className="text-sm text-zinc-400">Growth insights will appear after connected social accounts collect enough real performance data.</p></Panel>}
        {INSIGHTS.map((it, i) => (
          <Panel key={i} data-testid={`growth-${i}`} className="flex flex-col sm:flex-row sm:items-center gap-4">
            <div className="flex-1">
              <div className="flex items-center gap-2 mb-1">
                <Sparkle size={15} weight="fill" className="text-[#00E5FF]" />
                <Tag>Observation</Tag>
              </div>
              <p className="text-sm text-white">{it.obs}</p>
            </div>
            <button data-testid={`growth-idea-${i}`} onClick={() => toast.success(`"${it.idea}" sent to Story AI`)}
              className="shrink-0 inline-flex items-center gap-2 rounded-full bg-magic px-4 py-2 text-sm font-semibold text-black hover:opacity-90 transition-opacity">
              Create Similar Idea <ArrowRight size={15} weight="bold" />
            </button>
          </Panel>
        ))}
      </div>
    </div>
  );
}
